import { dataHooks } from '@wix/data-hooks';

export const templateGalleryEmptyFooterDataHooks = dataHooks<{
  footerContainer: {};
}>('template-gallery-empty-footer');
